<template>
    <b-modal
        v-model="shown"
        centered
        :title="title"
        lazy
    >
        <div>

            <!-- Name -->
            <b-form-group>
                <label>Name</label>
                <b-form-input v-model="$v.name.$model" />
                <b-form-invalid-feedback :force-show="$v.$dirty && !$v.name.required">
                    Please enter a tab name.
                </b-form-invalid-feedback>
            </b-form-group>
            <!--/ Name -->

            <!-- Description -->
            <b-form-group>
                <label>Description</label>
                <b-form-textarea v-model="description" />
            </b-form-group>
            <!--/ Description -->

            <div v-if="isQuote">
                <!-- Footer -->
                <b-form-group>
                    <label>Footer</label>
                    <b-form-textarea v-model="footer" />
                </b-form-group>
                <!--/ Footer -->

                <!-- Hide Columns -->
                <b-form-group>
                    <div><label>Hide Columns</label></div>
                    <b-form-checkbox-group
                        v-model="hideColumnsSelected"
                        name="hide_columns"
                    >
                        <b-form-checkbox
                            v-for="option in hideColumnsOptions"
                            :key="option.value"
                            :value="option.value"
                        >
                            {{ option.text }}
                        </b-form-checkbox>
                    </b-form-checkbox-group>
                </b-form-group>
                <!--/ Hide Columns -->

                <!-- Hide costs-->
                <b-form-group>
                    <b-form-checkbox v-model="hideCosts">
                        Hide costs
                    </b-form-checkbox>
                </b-form-group>
                <!--/ Hide costs-->
            </div>

        </div>
        <div slot="modal-footer">
            <b-btn
                variant="default"
                class="mr-2"
                @click="close()"
            >
                Close
            </b-btn>
            <Button
                variant="success"
                :loading="submitLoading"
                :disabled="$v.$invalid"
                @click="handleSubmit()"
            >
                Save
            </Button>
        </div>
    </b-modal>
</template>

<script>
import required from 'vuelidate/lib/validators/required';
import vueComponentReset from '@ianwalter/vue-component-reset';

const resetMixin = vueComponentReset(() => ({
    shown: false,
    id: null,
    title: '',
    name: '',
    description: '',
    footer: '',
    hideColumnsSelected: [],
    hideColumnsOptions: [
        { text: 'Type', value: 'type' },
        { text: 'Description', value: 'description' },
        { text: 'Quantity', value: 'quantity' },
        { text: 'Duration', value: 'duration' },
        { text: 'Unit price', value: 'unit_price' },
        { text: 'Total price', value: 'total_price' },
    ],
    hideCosts: false,
    submitLoading: false,
}));

export default {

    mixins: [
        resetMixin,
    ],

    validations: {
        name: {
            required,
        },
    },

    computed: {
        isQuote() {
            return this.$store.getters['costable/isQuote'];
        },
    },

    created() {
        this.$eventBus.$on(this.$events.openAddTabModal, () => {
            this.$v.$reset();
            this.reset();
            this.title = 'Add Tab';
            this.open();
        });

        this.$eventBus.$on(this.$events.openEditTabModal, (tab) => {
            this.$v.$reset();
            this.reset();
            this.id = tab.id;
            this.title = 'Edit Tab';
            this.name = tab.name;
            this.description = tab.description;
            this.footer = tab.footer;
            this.hideColumnsSelected = tab.hidden_columns;
            this.hideCosts = tab.hide_costs;
            this.open();
        });
    },

    methods: {
        async handleSubmit() {
            this.submitLoading = true;
            if (this.id) {
                // edit
                await this.$store.dispatch('costable/updateTab', {
                    tabId: this.id,
                    name: this.name,
                    description: this.description,
                    footer: this.footer,
                    hiddenColumns: this.hideColumnsSelected,
                    hideCosts: this.hideCosts,
                });
            } else {
                // create
                await this.$store.dispatch('costable/storeTab', {
                    name: this.name,
                    description: this.description,
                    footer: this.footer,
                    hiddenColumns: this.hideColumnsSelected,
                    hideCosts: this.hideCosts,
                });
            }
            this.submitLoading = false;
            this.close();
        },
        open() {
            this.shown = true;
        },
        close() {
            this.shown = false;
        },
    },

};
</script>
